export default __webpack_public_path__ + "img/2e0b89f18368cd50cf9458b95545e7b8.svg";